// removed by extract-text-webpack-plugin
module.exports = {"sec":"PointInfo__sec__gKhWrNGX","points":"PointInfo__points__Dv95h1wn","fresh":"PointInfo__fresh__3J7fZDOi"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PointInfo/PointInfo.scss
// module id = gQuc
// module chunks = 0